export class DateProvider {
    static getUTCDate(): Date {
        const now = new Date();
        return now;
    }
}